import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--narrow js-main-content" }
const _hoisted_2 = { class: "gfu-content-head" }
const _hoisted_3 = {
  class: "gfu-hd gfu-hd--h1",
  "data-qa": "page-title"
}
const _hoisted_4 = { class: "gfu-box gfu-box--huge _mb-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_footer_navigation = _resolveComponent("footer-navigation")
  const _component_content_renderer = _resolveComponent("content-renderer")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_footer_navigation, {
      "current-page": $props.scope,
      "group-type": ['system']
    }, null, 8 /* PROPS */, ["current-page"]),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString($options.title), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!$options.hasSummary)
          ? (_openBlock(), _createBlock(_component_content_renderer, {
              key: 0,
              content: $props.contents
            }, null, 8 /* PROPS */, ["content"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_content_renderer, { content: $props.summary }, null, 8 /* PROPS */, ["content"]),
              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "_mt-6" }, "The above is a summary of the document. Read it in full below:", -1 /* CACHED */)),
              _createElementVNode("div", {
                class: _normalizeClass(["gfu-collapsible _mt-3", { 'gfu-collapsible--expanded': $data.isExpanded }])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["gfu-collapsible__header", { 'gfu-collapsible__header--expanded': $data.isExpanded }]),
                  onClick: _cache[0] || (_cache[0] = $event => ($data.isExpanded = !$data.isExpanded)),
                  "data-qa": "terms-document:ToggleContents"
                }, _toDisplayString($options.title), 3 /* TEXT, CLASS */),
                _createElementVNode("div", {
                  class: _normalizeClass(["gfu-collapsible__content _px-2", { 'gfu-collapsible__content--expanded': $data.isExpanded }])
                }, [
                  _createVNode(_component_content_renderer, { content: $props.contents }, null, 8 /* PROPS */, ["content"])
                ], 2 /* CLASS */)
              ], 2 /* CLASS */)
            ], 64 /* STABLE_FRAGMENT */))
      ])
    ])
  ]))
}